<template>
    <div>
        <FullscreenLoading v-if="isLoading" />

        <Modal :show="showDeleteModal" @close="showDeleteModal = false" :custom_modal_class="'modal-xs fullwidth-modal'">
            <div slot="header">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('users.delete_title') }}</h5>
                    <button type="button" class="close" @click="showDeleteModal = false" aria-label="Close"><span aria-hidden="true">×</span></button>
                </div>
            </div>

            <div slot="body">
                <p>{{ $t('users.delete_confirm') }}</p>
            </div>

            <div slot="footer" class="w-100">
                <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    data-dismiss="modal"
                    @click="showDeleteModal = false"
                    :disabled="isLoading"
                >
                    {{ $t('general.close') }}
                </button>

                <button
                    type="button"
                    class="btn btn-danger btn-sm float-right"
                    data-dismiss="modal"
                    @click="deleteUser"
                >
                    {{ $t('users.delete_button') }}
                </button>
            </div>
        </Modal>
    </div>
</template>
<script setup>
    import Modal from '../Modal.vue';
    import { ref, watch } from 'vue';
    import { notifyError, notifySuccess } from '../../utils/notify';
    import { UserService } from '../../services/userService';
    import i18n from '../../utils/locale';
    import FullscreenLoading from '../FullscreenLoading.vue';

    const emit = defineEmits(['close', 'deleted']);
    const props = defineProps({
        user: {
            type: Object,
            required: true,
        },

        admin: {
            type: Boolean,
            default: false,
        },
    });

    const showDeleteModal = ref(true);
    const isLoading = ref(false);
    const errorMessage = ref(null);

    watch(() => showDeleteModal.value, () => {
        emit('close');
    });

    async function deleteUser() {
        isLoading.value = true;

        try {
            await UserService.getInstance().deleteUser(props.user.id, props.admin);
            emit('deleted');
            notifySuccess(i18n.t('users.user_deleted'));
        } catch (exception) {
            errorMessage.value = exception?.response?.data?.message || i18n.t('general.something_went_wrong');

            notifyError(exception);
        } finally {
            isLoading.value = false;
        }
    }
</script>
